import mixpanel from '@/plugins/mixpanel';

const sendToMixPanel = (eventName, data) => {
  setTimeout(() => {
    try {
      mixpanel.track(eventName, data);
    } catch (err) {
      console.error(err);
      throw new Error(`Mixpanel sync failed for ${eventName}`);
    }
  });
};

// eslint-disable-next-line import/prefer-default-export
export { sendToMixPanel };
